import { apiSlice } from "../../app/services/authServices";

export const dispatchSlice = apiSlice.injectEndpoints({
    tagTypes: ["Dispatch"],
    endpoints: builder => ({
        createTrip: builder.mutation({
            query: (data) => ({
                url: `TripDispatch/CreateTrip`,
                method: 'POST',
                body: data,
            }),
        }),
        editTrip: builder.mutation({
            query: (data) => ({
                url: `TripDispatch/EditTripDetails`,
                method: 'POST',
                body: data,
            }),
        }),
        flipOrder: builder.mutation({
            query: (body) => ({
                url: `TripDispatch/UpdateManualOrderClassification`,
                method: 'POST',
                body,
            }),
        }),
        getActiveTripsList: builder.query({
            query: (divisionID) => ({
                url: `TripDispatch/GetActiveTripsList?divisionID=${divisionID}`,
                method: 'GET',
            }),
        }),
        assignTripToOrder: builder.mutation({
            query: (body) => ({
                url: `TripDispatch/AssignTripToOrder`,
                method: 'POST',
                body: body,
            }),
        }),
        getOrdersByTrip: builder.query({
            query: ({ tripId, divisionId }) => ({
                url: `TripDispatch/GetOrdersByTrip?tripId=${tripId}&divisionId=${divisionId}`,
                method: 'GET',
            }),
        }),
        getAllOpenTripOrders: builder.query({
            query: (divisionID) => ({
                url: `TripDispatch/GetAllOpenTripOrders?divisionID=${divisionID}`,
                method: 'GET',
            }),
        }),
        getAllPortEntries: builder.query({
            query: () => ({
                url: `TripDispatch/GetAllPortEntries`,
                method: 'GET',
            }),
        }),
        updateTripStatus: builder.mutation({
            query: (body) => ({
                url: `TripDispatch/UpdateTripStatus`,
                method: 'POST',
                body: body,
            }),
        }),
        getSelectedTripDetails: builder.query({
            query: ({ tripId, divisionId }) => ({
                url: `TripDispatch/GetSelectedTripDetails?tripId=${tripId}&divisionId=${divisionId}`,
                method: 'GET',
            }),
        }),
        getDriversForTransferOptions: builder.query({
            query: () => ({
                url: `TripDispatch/GetDriversForTransferOptions`,
                method: 'GET',
            }),
        }),
        getOrderTransferOptions: builder.query({
            query: () => ({
                url: `TripDispatch/GetOrderTransferOptions`,
                method: 'GET',
            }),
        }),
        getTripOrdersClassification: builder.query({
            query: (body) => ({
                url: `TripDispatch/GetTripOrdersClassification?tripId=${body.tripId}&divisionId=${body.divisionId}&tripStatus=${body.tripStatus}`,
                method: 'GET',
            }),
        }),
        saveOrderTransferOptions: builder.mutation({
            query: (body) => ({
                url: `TripDispatch/SaveOrderTransferOptions`,
                method: 'POST',
                body: body,
            }),
        }),
        addDriverToOrder: builder.mutation({
            query: (body) => ({
                url: `TripDispatch/AddDriverToOrder`,
                method: 'POST',
                body: body,
            }),
        }),
        removeDriverFromOrder: builder.mutation({
            query: (body) => ({
                url: `TripDispatch/RemoveDriverFromOrder`,
                method: 'POST',
                body: body,
            }),
        }),
        updateOrderStatus: builder.mutation({
            query: (body) => ({
                url: `TripDispatch/UpdateOrderStatus`,
                method: 'POST',
                body: body,
            }),
        }),
        getAllTrailers: builder.query({
            query: () => ({
                url: `TripDispatch/GetAllTrailers`,
                method: 'GET',
            }),
        }),
        getVehiclesByDivision: builder.query({
            query: (divisionId) => ({
                url: `TripDispatch/GetVehiclesByDivision?divisionId=${divisionId}`,
                method: 'GET',
            }),
        }),
        getServicesByDivision: builder.query({
            query: (divisionId) => ({
                url: `TripDispatch/GetServicesByDivision?divisionId=${divisionId}`,
                method: 'GET',
            }),
        }),
        removeTripFromOrder: builder.mutation({
            query: (body) => ({
                url: `TripDispatch/RemoveTripFromOrder`,
                method: 'POST',
                body: body,
            }),
        }),
        assignLineHaulerToTrip: builder.mutation({
            query: (body) => ({
                url: `TripDispatch/AssignLineHaulerToTrip`,
                method: 'POST',
                body: body,
            }),
        }),
    })
});

export const { useFlipOrderMutation, useLazyGetSelectedTripDetailsQuery, useCreateTripMutation, useEditTripMutation, useLazyGetActiveTripsListQuery, 
    useAssignTripToOrderMutation, useLazyGetOrdersByTripQuery, useGetOrdersByTripQuery, useLazyGetAllOpenTripOrdersQuery, 
    useGetAllPortEntriesQuery, useUpdateTripStatusMutation, useGetDriversForTransferOptionsQuery, useGetOrderTransferOptionsQuery,
    useLazyGetTripOrdersClassificationQuery, useSaveOrderTransferOptionsMutation, useAddDriverToOrderMutation,
    useRemoveDriverFromOrderMutation, useUpdateOrderStatusMutation, useGetAllTrailersQuery, useGetVehiclesByDivisionQuery,
    useGetServicesByDivisionQuery, useRemoveTripFromOrderMutation, useAssignLineHaulerToTripMutation } = apiSlice;